// Fictional interface examples. These are NOT real deployed agents.
export const AGENTS = [
  {
    id: "AGENT-017",
    type: "HUMANOID COORDINATOR",
    status: "ONLINE",
    tasks: 184,
    reputation: "96.7%",
    balance: "18.24 USDC",
    capabilities: ["Planning", "Vision", "Coordination", "Payment"],
    history: [
      { id: "TASK #008967", name: "Perimeter Surveillance", result: "VERIFIED" },
      { id: "TASK #008812", name: "Depot Route Planning", result: "SETTLED" },
      { id: "TASK #008655", name: "Humanoid Fleet Sync", result: "SETTLED" },
    ],
    activity: [
      "09:41:07 — Coordination packet broadcast to 6 machines",
      "09:40:52 — Payment authorization signed · 0.12 USDC",
      "09:38:11 — Task #008967 verification confirmed",
      "09:31:44 — Capability registry heartbeat OK",
    ],
  },
  {
    id: "AGENT-042",
    type: "LOGISTICS PLANNER",
    status: "ONLINE",
    tasks: 312,
    reputation: "98.1%",
    balance: "42.81 USDC",
    capabilities: ["Route Optimization", "Fleet Dispatch", "Payment"],
    history: [
      { id: "TASK #009102", name: "Warehouse Mapping", result: "PROCESSING" },
      { id: "TASK #009010", name: "Corridor Reassignment", result: "SETTLED" },
    ],
    activity: [
      "10:02:19 — Rover cluster R-4 reassigned to Sector 07",
      "09:58:03 — Bid evaluation complete · 3 candidates",
    ],
  },
  {
    id: "AGENT-088",
    type: "VERIFICATION ORACLE",
    status: "ONLINE",
    tasks: 521,
    reputation: "99.3%",
    balance: "67.10 USDC",
    capabilities: ["Proof Verification", "Vision", "Attestation"],
    history: [
      { id: "TASK #008421", name: "Infrastructure Inspection", result: "OPEN" },
      { id: "TASK #008390", name: "Thermal Sweep Audit", result: "VERIFIED" },
    ],
    activity: ["10:04:55 — Attestation issued for TASK #008390"],
  },
  {
    id: "AGENT-131",
    type: "DRONE SWARM LEAD",
    status: "ONLINE",
    tasks: 97,
    reputation: "94.2%",
    balance: "9.66 USDC",
    capabilities: ["Swarm Control", "Thermal Imaging", "Coordination"],
    history: [{ id: "TASK #011820", name: "Solar Farm Scan", result: "OPEN" }],
    activity: ["10:01:36 — Swarm of 4 drones standing by"],
  },
  {
    id: "AGENT-205",
    type: "INDUSTRIAL SCHEDULER",
    status: "BUSY",
    tasks: 446,
    reputation: "97.5%",
    balance: "120.45 USDC",
    capabilities: ["Scheduling", "Robotic Arms", "Payment"],
    history: [{ id: "TASK #010204", name: "Assembly Line Rebalance", result: "PROCESSING" }],
    activity: ["10:03:02 — Arm cluster A-9 cycle time reduced 4.1%"],
  },
  {
    id: "AGENT-377",
    type: "ENERGY BROKER",
    status: "ONLINE",
    tasks: 268,
    reputation: "95.8%",
    balance: "54.02 USDC",
    capabilities: ["Energy Markets", "Negotiation", "Payment"],
    history: [{ id: "TASK #010552", name: "Charge Window Arbitrage", result: "SETTLED" }],
    activity: ["09:59:48 — Energy contract matched · 2.4 kWh"],
  },
];
